import {
  collection,
  doc,
  deleteDoc,
  setDoc,
  updateDoc,
} from "firebase/firestore";
import { httpsCallable } from "firebase/functions";
import Paycheck from "../../../classes/Paycheck";
import { db, functions } from "../../../boot/firebase";

export const GET_PAYCHECK = ({ dispatch }, { userID, paycheckID }) => {
  return dispatch("GET_DOC", {
    converter: Paycheck,
    path: Paycheck.getPath(userID, paycheckID),
    stateKey: "paychecks",
    id: paycheckID,
  });
};

export const LISTEN_PAYCHECK = (
  { dispatch },
  { userID, paycheckID, next, error, unlisten }
) => {
  return dispatch("LISTEN_DOC", {
    converter: Paycheck,
    path: Paycheck.getPath(userID, paycheckID),
    stateKey: "paychecks",
    id: paycheckID,
    next,
    error,
    unlisten,
  });
};

export const LISTEN_PAYCHECKS = (
  { dispatch },
  { userID, where, listenerPath, pagination, next, error, unlisten }
) => {
  const collectionPath = userID ? Paycheck.getPath(userID) : null;
  const collectionGroupName = userID ? null : "paychecks";
  return dispatch("LISTEN_COLLECTION", {
    converter: Paycheck,
    colGroup: collectionGroupName,
    path: collectionPath,
    stateKey: "paychecks",
    where,
    listenerPath: listenerPath || collectionPath || collectionGroupName,
    pagination,
    next,
    error,
    unlisten,
  });
};

export const SAVE_PAYCHECK = async ({ state }, payload) => {
  // Handle both { paycheck, original } and direct paycheck parameter
  let paycheck, original;
  if (payload.paycheck) {
    paycheck = payload.paycheck;
    original = payload.original || state.paychecks[payload.paycheck.id] || null;
  } else {
    // Legacy: paycheck passed directly
    paycheck = payload;
    original = state.paychecks[paycheck.id] || null;
  }

  if (!paycheck.id) {
    // New Paycheck
    paycheck.data.created = new Date();
    paycheck.data.createdBy = state.user.id;
    const ref = doc(collection(db, paycheck.path));
    paycheck.id = ref.id;
    await setDoc(ref, Paycheck.toFirestore(paycheck));
  } else {
    // Existing Paycheck
    paycheck.data.modified = new Date();
    paycheck.data.modifiedBy = state.user.id;
    await updateDoc(doc(db, paycheck.path), Paycheck.toFirestore(paycheck));
    // Note: Balance updates and commission marking as paid are handled by
    // the Cloud Function touchPaycheck in functions/paychecks.js
  }

  return paycheck;
};

export const DELETE_PAYCHECK = async (context, { userID, paycheckID }) => {
  // The touchPaycheck Cloud Function delete branch clears the `paycheck`
  // field on each linked commission, returning them to "Ready for
  // approval" status, and reverses any balance effect from the paycheck.
  return deleteDoc(doc(db, Paycheck.getPath(userID, paycheckID)));
};

export const CONFIRM_PAYCHECK_OVERRIDE = async ({ state }, id) => {
  await updateDoc(doc(db, Paycheck.getPath(state.user.id, id)), {
    modified: new Date(),
    modifiedBy: state.user.id,
    overrideConfirmed: true,
  });
};

const getPayrollReminderRecipients = httpsCallable(
  functions,
  "getPayrollReminderRecipients"
);

export const GET_PAYROLL_REMINDER_RECIPIENTS = async () => {
  const result = await getPayrollReminderRecipients();
  return result.data;
};

const sendPayrollReminders = httpsCallable(functions, "sendPayrollReminders");

export const SEND_PAYROLL_REMINDERS = async (
  context,
  { message, userIDs } = {}
) => {
  const result = await sendPayrollReminders({ message, userIDs });
  return result.data;
};
